// extracted by mini-css-extract-plugin
export var dividerContainer = "_a7-0";
export var line = "_a7-1";